'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bindActions = undefined;

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bindActions = exports.bindActions = function bindActions() {
  $(_Dom2.default.mainMenuItem).on('mouseover', function (event) {
    // console.log($(this));
    var $self = $(this);
    var section = $self.attr('data-menu-section');
    var menuGroup = $self.attr('data-menu-item-group');

    if (event.type == 'mouseover' && !$self.is('active')) {
      $('[data-menu-section][data-menu-item-group="' + menuGroup + '"]').removeClass('active');
      $self.addClass('active');
      $('[data-dropdown-menu][data-dropdown-menu-group="' + menuGroup + '"].active').removeClass('active');
      $('[data-dropdown-menu="' + section + '"][data-dropdown-menu-group="' + menuGroup + '"]').addClass('active');
    }
  });

  $(_Dom2.default.megaMenuLink).on('mouseover', function () {
    var activeTileSelector = '[data-menu-tiles-id="' + $(this).attr('data-menu-link-id') + '"]';

    $(_Dom2.default.megaMenuTiles).hide();
    $(_Dom2.default.megaMenuTiles).filter(activeTileSelector).css('display', 'flex');
  });
};